import { SVGProps } from 'react';

export type ArrowCircleIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const ArrowCircleIcon = ({ color = '#9667ED', ...props }: ArrowCircleIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5666 7.99102L9.99996 10.5577L7.43329 7.99102L6.24996 9.16602L9.99996 12.916L13.75 9.16602L12.5666 7.99102ZM9.99996 1.66602C5.39996 1.66602 1.66663 5.39935 1.66663 9.99935C1.66663 14.5993 5.39996 18.3327 9.99996 18.3327C14.6 18.3327 18.3333 14.5993 18.3333 9.99935C18.3333 5.39935 14.6 1.66602 9.99996 1.66602ZM9.99996 16.666C6.31663 16.666 3.33329 13.6827 3.33329 9.99935C3.33329 6.31602 6.31663 3.33268 9.99996 3.33268C13.6833 3.33268 16.6666 6.31602 16.6666 9.99935C16.6666 13.6827 13.6833 16.666 9.99996 16.666Z"
      fill={color}
    />
  </svg>
);
